import React from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const ServicesStatus = ({ row }) => {
  return (
    <>
      {row.serviceStatus ? (
        <span
          style={{
            color: "#4AA785",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FiberManualRecordIcon
            fontSize="small"
            sx={{ fontSize: 10, mr: 0.2 }}
          />
          <span>Active</span>
        </span>
      ) : (
        <span
          style={{
            color: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FiberManualRecordIcon
            fontSize="small"
            sx={{ fontSize: 10, mt: 0.2, mr: 0.2 }}
          />
          {/* <img alt="DotColorless" src={DotColorless} /> */}
          <span>Inactive</span>
        </span>
      )}
    </>
  );
};

export default ServicesStatus;
